/**
 * Misafir sipariş takip URL'si — giriş gerektirmez.
 */
export function buildGuestOrderTrackPath({ orderNumber, email, lang = 'tr' } = {}) {
  const params = new URLSearchParams();
  if (orderNumber) params.set('order_number', String(orderNumber));
  if (email) params.set('email', String(email).trim());
  const qs = params.toString();
  const code = (lang || 'tr').split('-')[0];
  const prefix = code && code !== 'en' ? `/${code}` : '';
  return `${prefix}/track${qs ? `?${qs}` : ''}`;
}

export function saveGuestCheckoutContext({ orderNumber, email }) {
  try {
    if (email) sessionStorage.setItem('guest_checkout_email', String(email).trim());
    if (orderNumber) sessionStorage.setItem('guest_checkout_order', String(orderNumber));
  } catch {
    /* ignore */
  }
}

export function readGuestCheckoutContext() {
  try {
    return {
      email: sessionStorage.getItem('guest_checkout_email') || '',
      orderNumber: sessionStorage.getItem('guest_checkout_order') || '',
    };
  } catch {
    return { email: '', orderNumber: '' };
  }
}
